<!-- 主要內容容器 -->
<div class="main-content-container">
  <!-- 右上角按鈕區域 -->
  <div class="header-buttons-container">
    <button (click)="openUserProfile()" class="btn btn-outline-primary profile-btn">
      <i class="fa fa-user-edit me-2"></i>
      {{ 'user_profile.button_text' | translate }}
    </button>
    <button (click)="logout()" class="btn btn-primary logout-btn">
      <i class="fa fa-sign-out-alt me-2"></i>
      {{ 'common.logout' | translate }}
    </button>
  </div>

  <div *ngIf="show_target == 'department'">

  <div *ngIf="departments.introduce" class="lobby-info" [innerHTML]="departments.introduce">
  </div>
<div class="row row-cols-1 row-cols-md-3 g-4">
  <div class="col" *ngFor="let item of departments.items">

    <a (click)="filterAssistants(item.dep_id)" target="_blank" style="cursor: pointer;" class="text-decoration-none">
      <div class="card">
        <img *ngIf="item.dep_image_url" [src]="item.dep_image_url" class="card-img-top" [alt]="item.dep_name">
        <div *ngIf="!item.dep_image_url && item.dep_text && item.dep_bg_color" class="card-header text-center" [style.background-color]="item.dep_bg_color">
          <span class="card-title-text" [style.color]="item.dep_font_color || 'inherit'">{{ item.dep_text }}</span>
        </div>
        <div *ngIf="!item.dep_image_url && (!item.dep_text || !item.dep_bg_color)" class="card-header text-center">
          <span class="card-title-text">{{ item.dep_name }}</span>
        </div>
        <div class="card-body">
          <h5 class="card-title">{{ item.dep_name }}</h5>
          <p class="card-text">{{ item.dep_content }}</p>
        </div>
        <div class="card-footer">
          <small class="text-muted" [innerHTML]="item.dep_memo"></small><br>
        </div>
      </div>
    </a>
  </div>
</div>

</div>



<div *ngIf="show_target == 'assistants' ">
  <div *ngIf="this.depId" class="d-flex justify-content-start mb-4">
  <button (click)="backToDepartments()" class="btn btn-primary d-flex align-items-center">
    <i class="bi bi-arrow-left me-2"></i>{{ 'lobby.back_to_departments' | translate }}
  </button>
</div>

  <div *ngIf="lobbyinfotext != ''" class="lobby-info" [innerHTML]="lobbyinfotext">
  </div>

  <div  class="row row-cols-1 row-cols-md-3 g-4">
    <div class="col" *ngFor="let item of ShowAssistantDataItem">
      <a (click)="(item.enable) && gotoAI(item.assistantNo, currentDepartmentId)" target="_blank" style="cursor: pointer;"
        class="text-decoration-none" [class.disabled]="!item.enable"
        [style.pointer-events]="item.enable ? 'auto' : 'none'">
        <div class="card" [class.card-disabled]="!item.enable">
          <img *ngIf="item.imageurl" [src]="item.imageurl" class="card-img-top" [alt]="item.title">
          <div *ngIf="!item.imageurl && item.assistant_text && item.assistant_bg_color && item.assistant_font_color" class="card-header text-center" [style.background-color]="item.assistant_bg_color">
            <span class="card-title-text" [style.color]="item.assistant_font_color">{{ item.assistant_text }}</span>
          </div>
          <div *ngIf="!item.imageurl && (!item.assistant_text || !item.assistant_bg_color || !item.assistant_font_color)" class="card-header text-center">
            <span class="card-title-text">{{ item.title }}</span>
          </div>
          <div class="card-body">
            <h5 class="card-title">{{ item.title }}</h5>
            <p class="card-text">{{ item.content }}</p>
          </div>
          <div class="card-footer">
            <small class="text-muted" [innerHTML]="item.memo"></small><br>
          </div>
        </div>
      </a>
    </div>
  </div>
</div>

</div> <!-- 結束 main-content-container -->

<!-- 個人資料編輯模態框 -->
<app-user-profile-edit 
  *ngIf="showUserProfileModal"
  (closeModal)="closeUserProfile()"
  (profileUpdated)="onProfileUpdated()">
</app-user-profile-edit>
